import type { ReactNode } from 'react';
import { Button, Empty, Result, Skeleton, Table, type TableProps } from 'antd';

export interface ProTableProps<T> extends Omit<TableProps<T>, 'dataSource' | 'loading'> {
  data: T[];
  loading?: boolean;
  tableLoading?: TableProps<T>['loading'];
  error?: string | null;
  emptyText?: string;
  emptyChildren?: ReactNode;
  skeletonRows?: number;
  onRetry?: () => void;
}

export default function ProTable<T extends object>({
  data,
  loading = false,
  tableLoading = false,
  error = null,
  emptyText = '暂无数据',
  emptyChildren,
  skeletonRows = 5,
  onRetry,
  ...rest
}: ProTableProps<T>) {
  if (loading) {
    return (
      <div className="pro-table-skeleton" style={{ padding: '8px 0' }}>
        <Skeleton active paragraph={{ rows: skeletonRows }} />
      </div>
    );
  }

  if (error) {
    return (
      <Result
        status="error"
        title={`加载失败：${error}`}
        extra={
          onRetry && (
            <Button type="primary" onClick={onRetry}>
              重试
            </Button>
          )
        }
      />
    );
  }

  if (!data.length && !tableLoading) {
    return <>{emptyChildren ?? <Empty description={emptyText} />}</>;
  }

  return (
    <Table<T> dataSource={data} loading={tableLoading} pagination={false} size="middle" {...rest} />
  );
}
